import { useEffect, useState } from 'react';
import { api } from './api';

export interface WeekBoundary {
  /** Weekday the household's week starts on, Monday = 0. */
  weekStartsOn: number;
  /** The week containing today. */
  thisWeek: string;
  /** The week worth opening the planner on. */
  planningWeek: string;
}

/**
 * Where this household's week starts.
 *
 * A week runs from one main shop to the next, so its boundary depends on when
 * the household shops — the browser cannot know that, and used to assume
 * Monday for everybody. Null while it is still being fetched, so callers wait
 * rather than rendering a Monday and then jumping.
 */
export function useWeekBoundary(today: string): WeekBoundary | null {
  const [boundary, setBoundary] = useState<WeekBoundary | null>(null);

  useEffect(() => {
    let live = true;
    void api
      .weekTarget(today)
      .then((result) => {
        if (live) setBoundary(result);
      })
      .catch(() => {
        // A household that cannot be read is a household nobody is signed in
        // to; the page's own error handling covers it.
      });
    return () => {
      live = false;
    };
  }, [today]);

  return boundary;
}
